(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/customer-service/assets/javascripts/models/terms.js') >= 0) return;  svs.modules.push('/modules/customer-service/assets/javascripts/models/terms.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.customer_service.models.Terms = Backbone.Model.extend({
    initialize: function() {
      if (svs.customer_service.data.forms) {
        this.set({
          forms: svs.customer_service.data.forms || {}
        });
      } else {
        this.getDocumentsFromCMS('forms');
      }
    },
    getDocumentsFromCMS: function(key) {
      var parentId = {
          forms: svs.customer_service.data.config.formsFolderId
        },
        options = {
          method: 'GET',
          path: new svs.content.shared.ContentUrlBuilder('basicfilter').addParams({ parentId: parentId[key], count: 100 }).build()
        },
        self = this;
      svs.core.jupiter.call(
        options,
        function(data) {
          svs.customer_service_logger.debug('Successful fetching ' + key);
          var model = {};
          model[key] = data.result;
          self.set(model);
        },
        function(xhr, textStatus, errorThrown) {
          svs.customer_service_logger.error('Error in fetching ' + key + ', ' + errorThrown);
        }
      );
    }
  });
})(Backbone, _, svs);

 })(window);